module.exports = __webpack_public_path__ + "Daniel_E_Seiner_Web_Over.jpg?abf766a04ed0a5aa1fac663e37045ef6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/Daniel_E_Seiner_Web_Over.jpg
// module id = 168
// module chunks = 0